<script setup lang="ts">
const storeIndex = useStoreIndex()
const storeUser = useStoreUser()
const isAuthing = ref(true)

definePageMeta({ layout: 'layout-single' })

onMounted(() => {
  if (storeUser.state.isLogin) {
    navigateTo('/')
  } else {
    isAuthing.value = false
  }
})

const setHead = () => {
  const baseTitle = 'ログイン'
  const headTitle = 'ログイン | IMメンバー'
  const headDesc = `日本最大級のミュージアム情報サイト、アイエム［インターネットミュージアム］による、ミュージアム情報の掲示板。ミュージアムに関連する話題なら、どなたでもご利用いただけます。美術館・博物館の情報はアイエムで！`
  const items = [
    {
      text: baseTitle,
      disabled: true,
    },
  ]
  storeIndex.setBreadCrumbs(items)

  useHead({
    title: headTitle,
    meta: [
      {
        name: 'description',
        content: headDesc,
      },
      {
        property: 'og:title',
        content: 'ログイン | IMメンバー | アイエム［インターネットミュージアム］',
      },
    ],
  })
}

const initPage = () => {
  setHead()
}
initPage()
</script>

<template>
  <div
    v-if="!isAuthing"
    class="p-singlePage"
  >
    <h2 class="c-heading_page">
      ログイン
    </h2>
    <LoginPanel />
  </div>
</template>
